/* eslint-disable react-hooks/exhaustive-deps */
import { FilterBar, FormGroup, Label, Toggle, Select } from '@celltrak/ui-components';

import useAgenciesFilterBar from './hooks';

function AgenciesFilterBar() {
  const {
    showResetButton,
    handleFilterChanges,
    handleResetFilter,
    handleToggleSwitch,
    filters,
    partnersOptions,
  } = useAgenciesFilterBar();

  return (
    <FilterBar
      onPrimaryClick={() => handleResetFilter()}
      buttonSize="sm"
      showPrimaryButton={showResetButton}
      showSecondaryButton={false}
      primaryButtonLabel="Reset"
    >
      <FormGroup>
        <Label for="partner-filter" size="sm">
          Partner
        </Label>
        <Select
          id="partner-filter"
          size="sm"
          options={partnersOptions}
          value={filters.partnerID}
          onChange={handleFilterChanges('partnerID')}
        />
      </FormGroup>
      <FormGroup>
        <Toggle
          id="active-filter"
          size="sm"
          label="active"
          checked={filters.active}
          onChange={handleToggleSwitch}
        />
      </FormGroup>
    </FilterBar>
  );
}

export default AgenciesFilterBar;
